const normalize = (value) => {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

export const getDashboardList = (dashboards) => {
  if (!dashboards) return [];
  return Array.isArray(dashboards) ? dashboards : Object.values(dashboards);
};

export const findTelemetryDashboard = (dashboards) => {
  return getDashboardList(dashboards).find((dashboard) => {
    const candidates = [
      dashboard?.slug,
      dashboard?.code,
      dashboard?.key,
      dashboard?.type,
      dashboard?.dashboard_type,
      dashboard?.dashboardType,
      dashboard?.name,
    ].map(normalize);

    return (
      candidates.includes("telemetry") ||
      candidates.includes("telemetria")
    );
  });
};

export const dashboardHasPanels = (dashboard) => {
  if (!dashboard) return false;

  const panelKeys = [
    "panels",
    "xy_graph_panels",
    "xyz_graph_panels",
    "counter_panels",
    "status_panels",
    "xyGraphPanels",
    "xyzGraphPanels",
    "counterPanels",
    "statusPanels",
  ];

  return panelKeys.some((key) => {
    const value = dashboard[key];

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (value && typeof value === "object") {
      return Object.keys(value).length > 0;
    }

    if (typeof value === "number") {
      return value > 0;
    }

    return false;
  });
};